// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__13ulB","title":"styles_title__23w78"};